import { NgModule } from '@angular/core';
import { PromemoriaComponent } from './promemoria.component';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { ReactiveFormsModule } from '@angular/forms';
import { Button } from "primeng/button";
import { PromemoriaDettaglioComponent } from './components/promemoria-dettaglio.component';
import { DialogModule } from "primeng/dialog";
import { DialogModalPromemoriaComponent } from './components/dialog-modal-promemoria.component';
import { BadgeModule } from 'primeng/badge';
import { PromemoriaBadgeComponent } from './components/promemoria-badge.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    PaginatorModule,
    ReactiveFormsModule,
    Button,
    DialogModule,
    BadgeModule,
  ],
  declarations: [
    PromemoriaComponent,
    PromemoriaDettaglioComponent,
    DialogModalPromemoriaComponent,
    PromemoriaBadgeComponent
  ],
  exports: [
    PromemoriaBadgeComponent
  ],
})
export class PromemoriaModule { }
